// extracted by mini-css-extract-plugin
export default {"Item":"Item_Item__L9iC7","HeaderContainer":"Item_HeaderContainer__Zogi9","Header":"Item_Header__foGlc","Text":"Item_Text__5jhIB","Button":"Item_Button__yUudA"};